import { Box } from '@mantine/core';
import clsx from 'clsx';
import React from 'react';
import classes from './IconWithDot.module.css';

type IconWithDotPositionPreset =
  | 'top'
  | 'top-right'
  | 'right'
  | 'bottom-right'
  | 'bottom'
  | 'bottom-left'
  | 'left'
  | 'top-left';

const dotPositionClassNames: Record<IconWithDotPositionPreset, string> = {
  top: classes.dotPositionTop,
  'top-right': classes.dotPositionTopRight,
  right: classes.dotPositionRight,
  'bottom-right': classes.dotPositionBottomRight,
  bottom: classes.dotPositionBottom,
  'bottom-left': classes.dotPositionBottomLeft,
  left: classes.dotPositionLeft,
  'top-left': classes.dotPositionTopLeft,
};

interface IconWithDotProps {
  dotColor: string;
  dotPosition?:
    | IconWithDotPositionPreset
    | {
        top?: number;
        right?: number;
        bottom?: number;
        left?: number;
      };
  dotSize?: number;
  icon: React.ReactNode;
  className?: string;
  width?: number;
  height?: number;
}

export function IconWithDot({
  dotColor,
  dotPosition = 'bottom-right',
  dotSize = 13,
  icon,
  className,
  width,
  height,
}: React.PropsWithChildren<IconWithDotProps>) {
  const isPresetPosition = typeof dotPosition === 'string';
  const dotPositionClassName = isPresetPosition ? dotPositionClassNames[dotPosition] : undefined;
  const dotPositionStyle = isPresetPosition ? undefined : dotPosition;

  return (
    <Box w={width} h={height} className={clsx(classes.iconWithDot, className)}>
      <Box className={classes.iconWithDotIcon}>{icon}</Box>
      <Box
        className={clsx(classes.iconWithDotDot, dotPositionClassName)}
        bg={dotColor}
        style={{
          width: dotSize,
          height: dotSize,
          ...dotPositionStyle,
        }}
      />
    </Box>
  );
}
